import React, { Fragment } from "react";
import { Row, Col, FormGroup, Label } from "reactstrap";

function RefundReturnReasonForm(props) {
  const { errors, control, register, setValue, trigger, getValues } = props;
  return (
    <Fragment>
      <Row>
        <Col>
          <FormGroup>
            <Label className="col-form-label" style={{fontSize : "1rem", fontWeight : 500}}>Reason <span style={{color:"red"}}>*</span></Label>
            <textarea name="name" type="text"  rows={5} {...register("reason")} className={`form-control ${errors.reason ? "is-invalid" : ""}`} />
            <div className="invalid-feedback">{errors.reason?.message}</div>
          </FormGroup>
        </Col>
      </Row>
    </Fragment>
  );
}

export default RefundReturnReasonForm;
